<template>
  <div>
    <!-- INICIO CADASTRO -->
    <papel-seguranca-consumo v-if="modalConsumo"
                             :prop-custas="papelSegurancaCusta"
                             :prop-ordem-servico="true"
                             @atualizarAto="atopapelSegurancaCusta"
                             @onHide="(custas) => hidePapelSegurancaConsumo(custas)" />

    <ordens-servico-form :prop-custas="propCustas"
                         :prop-tipo="propTipo"
                         :prop-registro="propRegistro"
                         :prop-ordem-servico="ordemServico"
                         :prop-ordem-servico-sem-registro="propOrdemServicoSemRegistro"
                         :prop-edit-os="true"
                         @onAdd="onAdd"
                         @onChangeServico="onChangeServico"
                         @onChangeOrdemServico="onChangeOrdemServico"
                         @onDelete="onDelete"
                         @onCancel="(selos, item, index) => onCancel(selos, item, index)"
                         @deleteSelos="deleteSelos"
                         @imprimir="imprimir"
                         @deleteOS="deleteOS"
                         @imprimirRecibo="imprimirRecibo"
                         @rechargeOS="rechargeOS" />

    <!-- <div class="row mt-5">
      <div class="col text-right">
        <button class="btn btn-sm btn-light"
                @click="$emit('onBack')">
          Voltar
        </button>

        <button class="btn btn-sm btn-secondary ml-2"
                @click="atualizarOs().confirmSaveOs()">
          Salvar OS
        </button>
      </div>
    </div> -->
    <!-- FIM CADASTRO -->

    <!-- INICIO - MODAL EXCLUSÃO/CANCELAMENTO SELO -->
    <b-modal v-if="modal.show"
             id="modal-excluir-cancelar-selo"
             ref="modal-excluir-cancelar-selo"
             :visible="true"
             centered
             hide-header
             size="md"
             hide-footer
             @hide="cancelModal()">
      O item "<b>{{ modal.data.custa.ato }}</b>" <br>
      possui {{ modal.data.seloItemOs.length }} selo{{ modal.data.seloItemOs.length > 1 && 's' || '' }}.
      <br>
      <br>
      <div v-if="modal.data.seloItemOs.length > 0"
           class="row">
        <div class="col-12">
          Escolha uma ação{{ modal.data.seloItemOs.length > 1 && ' para cada um' || '' }}:
        </div>
        <div v-for="itemSelo of modal.data.seloItemOs"
             :key="`list_selos_${ itemSelo.selo.num_selo }`"
             class="text-center mt-2 col-12 mb-1">
          <b class="pt-11">- Selo: {{ itemSelo.selo.num_selo }}
            <small v-if="verifyTimeDiff(itemSelo.selo)"
                   class="text-primary">
              - criado a mais de 72h.
            </small>
          </b><br>

          <div class="ml-4 pl-4 mr-4 pr-4">
            <span class="custom-control custom-radio custom-control-inline">
              <input
                :id="`excluir_${ _uid }_${ itemSelo.selo.num_selo }`"
                v-validate="{ required: true }"
                type="radio"
                :name="`name_${ itemSelo.selo.num_selo }`"
                value="deleteds"
                class="custom-control-input"
                :class="{'is-invalid' : errors.has(`name_${ itemSelo.selo.num_selo }`)}"
                @change="seloModalAction(itemSelo, 'deleteds')">
              <label
                class="custom-control-label"
                :for="`excluir_${ _uid }_${ itemSelo.selo.num_selo }`"><small>Excluir</small></label>
            </span>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                :id="`cancelar_${ _uid }_${ itemSelo.selo.num_selo }`"
                v-validate="{ required: true }"
                type="radio"
                :name="`name_${ itemSelo.selo.num_selo }`"
                value="canceleds"
                class="custom-control-input"
                :class="{'is-invalid' : errors.has(`name_${ itemSelo.selo.num_selo }`)}"
                @change="seloModalAction(itemSelo, 'canceleds')">
              <label
                class="custom-control-label"
                :for="`cancelar_${ _uid }_${ itemSelo.selo.num_selo }`"><small>Cancelar</small></label>
            </span>

            <div v-if="verifyInCanceleds(itemSelo)"
                 class="col-12">
              <label class="label">
                <small>
                  Digite o número da Ordem Judicial
                  <span v-if="!verifyTimeDiff(itemSelo.selo)"> (não obrigatório)</span>
                </small>
              </label>
            </div>
            <div v-if="verifyInCanceleds(itemSelo)"
                 class="col-8 offset-2">
              <input type="text"
                     class="form-control form-control-sm"
                     :name="`ordem_judicial_${ itemSelo.selo.num_selo }`"
                     @input="event => setOrdemJudicial(itemSelo, event)">
            </div>
          </div>
          <div />
        </div>
      </div>

      <div class="mt-2 row">
        <div class="col">
          <div class="row no-gutters justify-content-end align-items-center">
            <button class="btn btn-sm btn-dark mr-2"
                    @click="cancelModal()">
              Voltar
            </button>
            <button class="btn btn-sm btn-primary"
                    type="button"
                    @click="confirmAction()">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- FIM - MODAL EXCLUSÃO/CANCELAMENTO SELO -->
  </div>
</template>

<script>
  /* components */
  import OrdensServicoForm from "@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/OrdensServicoForm"
  import PapelSegurancaConsumo from "@/components/SofiaRei/PapelSeguranca/PapelSegurancaConsumo"

  /* services */
  import SelosService from "@/services/Registros/SelosService"
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"
  import CartorioConfigService from "@/services/CartorioConfigService"
  import PapelSegurancaLoteService from "@/services/PapelSeguranca/PapelSegurancaLoteService"
  import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"

  /* outros */
  import Swal from 'sweetalert2'
  import moment from 'moment'

  /* constants */
  import { LANCAR_OS, ADMIN } from "@/constants/permissions"
  import custas, {obterAtosComCodigo} from '@/constants/custas'

  /* outros */
  import {mapGetters} from "vuex"

  export default {
    name: "OrdensServicoEdicao",
    components: {
      OrdensServicoForm,
      PapelSegurancaConsumo
    },
    props: {
      propRegistroId: Number,
      propRegistro: { type: Object, default: () => { return {} }},
      propTipo: String,
      propCustas: {
        type: Array,
        default: () => []
      },
      propOrdemServico: {
        type: Object,
        default: () => {
          return {}
        }
      },
      propOrdemServicoSemRegistro: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        modal: {
          show: false,
          data: null,
          canceleds: [],
          deleteds: []
        },
        modalConsumo: false,
        papelSegurancaLote: false,
        papelSegurancaCusta: [],
        tiposImpressos: [],
        custas,
        ordemServico: {
          cpf_solicitante: null,
          nome_solicitante: null,
          registro_id: this.propRegistroId,
          valor_total: null,
          itens: [],
          data_cumprida: null
        },
        deleteds: { itens: []},
        selos: { canceleds: [], deleteds: [], restoreds: [] },
        updateds: {itens: []},
        LANCAR_OS,
        ADMIN,
        initialName: '',
        initialCPF: ''
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        user: 'auth/getUser'
      })
    },
    watch: {
      propOrdemServico () {
        this.init()
      }
    },
    beforeMount () {
      this.init()
    },

    methods: {
      async init () {
        this.ordemServico = {
          ...this.ordemServico,
          ...this.propOrdemServico
        }
        this.initialName = this.propOrdemServico.nome_solicitante
        this.initialCPF = this.propOrdemServico.cpf_solicitante

        if (this.propOrdemServico) {
          this.ordemServico.data_cumprida = moment(this.propOrdemServico.data_cumprida).format('YYYY-MM-DD')
        }

        const [papelSegurancaLoteStatus, tiposImpressos] = await Promise.all([
          CartorioConfigService.showByChave({ chave: 'PAPEL_SEGURANCA_STATUS' }),
          PapelSegurancaLoteService.listTipos()
        ])

        // deixamos a comparação de valor, para caso não tiver nada, ficar false
        this.papelSegurancaLote = papelSegurancaLoteStatus.valor === '1'
        this.tiposImpressos = tiposImpressos
      },
      atualizarOs () {
        const confirmSaveOs = async () => {
          const seloStatus = this.propOrdemServico.itens.filter(item => item.seloStatus === true)
          const editNome = this.initialName !== this.ordemServico.nome_solicitante
          const editCPF = this.initialCPF !== this.ordemServico.cpf_solicitante

          if (seloStatus.length && editNome || editCPF) {
            const confirmacao = await this.displayQuestion(
              'Atenção!',
              'A ordem de serviço possue selos gerados e já enviados ao TJSP. Ao confirmar a alteração, será gerado um selo retificador e enviado ao TJSP para atualização das informações.'
            )
            if (confirmacao.dismiss === 'cancel') return
          }

          if (this.selos.canceleds.length > 0 || this.selos.deleteds.length > 0 || this.selos.restoreds.length > 0) {
            objSwal.question.title = `Atenção!`
            objSwal.question.text = `Existem itens que terão selos excluídos e/ou cancelados. Deseja prosseguir?`
            objSwal.question.cancelButtonText = "Cancelar"
            objSwal.question.confirmButtonText = "Confirmar"

            Swal.fire(objSwal.question).then(status => {
              if (status.value === true) {
                saveOS(true)
              }
            })
          } else {
            saveOS()
          }
        }

        const saveOS = async (selosModify = false) => {
          // aguardamos a escolha dos papeis por parte do usuário 
          await this.papelSeguranca()
          try {
            // Verificamos a permissão no método pois a validação não informaria
            // o motivo correto
            // Se for suporte ou oficial não validamos
            const { groups, flag_oficial } = this.user

            let login = ''

            if (this.user) {
              login = this.user.login.split('_')[0]
            }

            if (groups && groups.length && !flag_oficial) {
              let access = false
              const permissions = [this.LANCAR_OS, this.ADMIN]

              groups.forEach(group => {
                const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

                if (permission && group.ativo) access = true
              })

              if (!access) {
                this.$emit('resultSaveOS', false)
                return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
              }
            } else if (login !== 'suporte' && !flag_oficial) {
              this.$emit('resultSaveOS', false)
              return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
            }

            loader({ text: 'Salvando O.S. ...', active: true })
            /*const responseOS = await storeOS(this.ordemServico);
            Object.assign(this.ordemServico, responseOS);*/

            await updateOs()

            // selosModify indica se houve alteração nos selos
            if (selosModify) {
              // criando variavel para contar erro de selos
              let erros = 0

              if (this.selos.canceleds.length > 0) {
                const canceled = await cancelSeloItem()
                if (!canceled) {
                  erros++
                }
              }

              // condicao com erro igual a 0 para não excluir o selo no tj
              // e no nosso banco ficar como se não tivesse excluido
              if (this.selos.deleteds.length > 0 && erros == 0) {
                const deleted = await deleteOSItem()
                if (!deleted) {
                  erros++
                }
              }


              // condicao com erro igual a 0 para não retificar o selo no tj
              // e no nosso banco ele continuar excluido/cancelado
              if (this.selos.restoreds.length > 0 && erros == 0) {
                const restored = await restoreSeloItem()
                if (!restored) {
                  erros++
                }
              }

              // caso não tiver nenhum erro irá prosseguir
              if (erros == 0) {
                // Validação exclusão selo
                await updateOSItem()
                await saveOSItem()
              } else {
                this.displayError('Não foi possível salvar', 'Houve erro na comunicação com o TJ. Tente novamente mais tarde, se o erro persistir entre em contato com o suporte.')
              }
            } else {
              // Validação exclusão selo
              let erroExcluirSelo = false
              await deleteOSItem().catch(() => erroExcluirSelo = true)
              if (erroExcluirSelo) {
                this.$emit('resultSaveOS', false)
                return
              }

              await updateOSItem()
              await saveOSItem()
            }

            loader({ text: '', active: false })
            this.$emit('resultSaveOS', this.propOrdemServicoSemRegistro, this.papelSegurancaCusta)
          } catch (e) {
            loader({ text: '', active: false })

            this.displayError('Erro!', e.response.data.message || 'Não foi possível editar a ordem de serviço. Tente novamente.')
          }
        }

        const saveOSItem = async () => {
          loader({ text: 'Salvando O.S. ...', active: true })
          const osItemPromisse = this.ordemServico.itens.map(async (item) => {
            if (!item.ordem_servico_item_id) {
              item.descricao = item.descricao || null

              // Se tiver a matrícula do pedido crc retiramos os espaços em branco
              item.matricula_pedido_crc = item.matricula_pedido_crc ? item.matricula_pedido_crc.replace(/\s/g, '') : null

              const osItem = await OrdensServicoService.storeOsItem(item)
              Object.assign(item, osItem)
              
              return osItem
            }
          })

          await Promise.all(osItemPromisse).then(() => {
            this.$emit('onGerarSelo', this.ordemServico, this.papelSegurancaCusta)
          }).catch(loader({ text: '', active: false }))

          loader({ text: '', active: false })
        }

        const updateOSItem = async () => {
          const {itens} = this.updateds

          for (const item of itens) {
            if (!item.ordem_servico_item_id) continue
            try {
              item.descricao = item.descricao || null

              // Se tiver a matrícula do pedido crc retiramos os espaços em branco
              item.matricula_pedido_crc = item.matricula_pedido_crc ? item.matricula_pedido_crc.replace(/\s/g, '') : null

              await OrdensServicoService.updateOsItem(item, item.ordem_servico_item_id)
            } catch (e) {
              console.error(e)
              throw e
            }
          }
        }
        const deleteOSItem = async () =>{
          const {itens } = this.deleteds
          const { deleteds } = this.selos

          if (deleteds && deleteds.length) {
            try {
              for (const selo_id of deleteds) {
                await SelosService.excluirSelo(selo_id)
              }
              return true
            } catch ({response}) {
              const { data: { message } } = response

              this.displayError(message || 'Não foi possível excluir o selo.')

              // throw 'Não foi possível excluir o selo.'
              return false
            }
          }

          if (itens && itens.length) {
            for (let item of itens) {
              try {
                await OrdensServicoService.destroyOsItem(item.ordem_servico_item_id)
              } catch (error) {
                this.displayError(error.message || 'Não foi possível excluir o item.')
              }
            }
          }
        }
        const cancelSeloItem = async () => {
          const { canceleds } = this.selos

          if (canceleds && canceleds.length) {
            try {
              for (const seloId of canceleds) {
                const itemOS = this.modal.data.seloItemOs.find(itemOS => itemOS.selo_id === seloId)

                let numOrdemJudicial = null

                if (itemOS && itemOS.selo) {
                  numOrdemJudicial = itemOS.selo.num_ordem_judicial
                }

                await SelosService.cancelarSelo(seloId, numOrdemJudicial)
              }
              return true
            } catch ({response}) {
              const {data: {message}} = response
              const {errors} = message

              if (errors && errors.length) {
                this.displayError(errors[0])
              } else {
                this.displayError(message || 'Não foi possível cancelar o selo.')
              }
              return false
            }

          }
        }
        const restoreSeloItem = async () =>{
          const { restoreds } = this.selos

          if (restoreds && restoreds.length) {
            try {
              for (const selo_id of restoreds) {
                await SelosService.retificarSelo(selo_id)
              }
              return true
            } catch ({response}) {
              const {data: {message}} = response
              const {errors} = message

              if (errors && errors.length) {
                this.displayError(errors[0])
              } else {
                this.displayError(message || 'Não foi possível restaurar o selo.')
              }
              return false
            }
          }
        }
        const updateOs = async () => {
          try {
            // Se tiver o número do pedido crc retiramos os caracteres especiais
            this.ordemServico.num_pedido_crc = this.ordemServico.num_pedido_crc ? this.ordemServico.num_pedido_crc.replace(/[^\w\s]/gi, '') : null

            const payload = this.ordemServico

            // Verificamos se a OS tem algum selo
            payload.existeSelo = !!payload.itens.find(item => item.seloStatus)

            await OrdensServicoService.updateOS(payload, payload.ordem_servico_id)
          } catch (error) {
            console.error(error)
            throw error
          }
        }
        return { saveOS, saveOSItem, updateOSItem, updateOs, cancelSeloItem, confirmSaveOs }
      },
      async displayQuestion (title, text, btnConfirm, btnCancel) {
        const { value: resposta } = await Swal.fire({
          title: title,
          text: text,
          showCancelButton: true,
          confirmButtonText: btnConfirm || 'Confirmar',
          cancelButtonText: btnCancel || 'Cancelar',
        })

        if (resposta) {
          return true
        } else {
          Swal.fire('Edição cancelada!')
          return false
        }
      },
      
      async waitResponseSegurancaConsumo () {
        this.modalConsumo = true
        const verify = (resolve) => {
          if (this.modalConsumo == true) {
            setTimeout(() => {
              return verify(resolve)
            }, 1000)
          } else {
            return resolve(true)
          }
        }
        return new Promise((resolve) => {
          return verify(resolve)
        })
      },
      async papelSeguranca () {
        loader({ text: 'Salvando O.S 3. ...', active: true })
        if (!this.papelSegurancaLote) return

        this.papelSegurancaCusta = []

        return new Promise(async (resolve) => {
          const itens = this.ordemServico.itens
          // tipos de selos que utilizam impressos de segurança
          let selosCustasImpressos

          for (const key in itens) {
            // pegamos o item pela chave
            const item = itens[key]

            if (!item.impressosSeguranca) continue

            if (item.ordem_servico_item_id) continue
            if (item.gerarSeloCheckbox && item.impressosSeguranca === false) {
              selosCustasImpressos = []     
            } else {
              selosCustasImpressos = ['PV', 'CE', 'AP', 'S1', 'S2', 'C1', 'C2', 'RA', 'CR', 'IV', 'DD', 'PC', 'AU', 'TR']
            }

            // pegamos os tipo de selo pelo codigo da custa
            let tipoSelos = []

            if (item.custa.codigo) {
              tipoSelos = obterAtosComCodigo(item.custa.codigo)
            } else if (item.tabelaCartorio && !!item.custa.tipoAtoSelo) {
              tipoSelos.push(item.custa.tipoAtoSelo.tipo_ato)
            }
            // se existirem selo
            if (tipoSelos.length > 0 && item.seloStatus) {
              const registroOficial = item.custa.registro_oficial && !item.custa.cartorio_id
              const consumirImpressoCustaOficial = registroOficial && tipoSelos.find(tipo => selosCustasImpressos.includes(tipo))
              const consumirImpressoCustaPersonalizada = !registroOficial && item.custa.tipo_impresso_seguranca_personalizado

              // tipos de selos que utilizam impressos de segurança
              if (consumirImpressoCustaOficial || consumirImpressoCustaPersonalizada) {
                this.papelSegurancaCusta.push({
                  index: key,
                  item,
                  papelSeguranca: [],
                  tipoSelos,
                  registroOficial,  
                  tipoImpresso: {
                    codigosAtos: [],
                    label: "",
                    value: ""
                  },
                  quantidade: item.quantidade
                })
              }
            }
          }
          if (this.papelSegurancaCusta.length > 0) {
            await this.waitResponseSegurancaConsumo()
          }
          return resolve(true)
        })
      },
      atopapelSegurancaCusta ( event, custa ) {
        let atoAtual = ""

        this.papelSegurancaCusta.forEach( (item, index ) => {
          if (index == custa.index) {
            switch (event) {
            case "Papel de segurança Registro Civil":
              atoAtual = "papel_de_seguranca_registro_civil"
              break
            case "Traslado":
              atoAtual = "traslado"
              break
            case "Apostilamento":
              atoAtual = "apostilamento"
              break
            case "Ficha de Firmas":
              atoAtual = "ficha_de_firmas"
              break
            case "Selo de autenticação":
              atoAtual = "selo_de_autenticacao"
              break
            case "Selo de reconhecimento de firma por autenticidade":
              atoAtual = "selo_de_reconhecimento_de_firma_por_autenticidade"
              break
            case "Selo de reconhecimento de firma por semelhança com valor 1":
              atoAtual = "selo_de_reconhecimento_de_firma_por_semelhanca_com_valor_1"
              break
            case "Selo de reconhecimento de firma por semelhança com valor 2":
              atoAtual = "selo_de_reconhecimento_de_firma_por_semelhanca_com_valor_2"
              break
            case "Selo de reconhecimento de firma por semelhança sem valor 1":
              atoAtual = "selo_de_reconhecimento_de_firma_por_semelhanca_sem_valor_1"
              break
            case "Selo de reconhecimento de firma por semelhança sem valor 2":
              atoAtual = "selo_de_reconhecimento_de_firma_por_semelhanca_sem_valor_2"
              break
            default:
            }
            item.tipoImpresso.value = atoAtual 
          }
        })

      },
      hidePapelSegurancaConsumo (custas) {
        this.modalConsumo = false

        if (!!custas) {
          this.papelSegurancaCusta = [ ...custas ]
        } else {
          this.papelSegurancaCusta = []
        }
      },
      onAdd (formServico) {
        if (formServico.ordem_servico_id == null) {
          formServico.ordem_servico_id = this.ordemServico.ordem_servico_id
        }
        this.ordemServico.itens.push({ ...formServico })
      },
      onChangeServico (formServico, index) {
        this.ordemServico.itens[index] = {...formServico}
        this.updateds.itens.push(this.ordemServico.itens[index])
      },
      onChangeOrdemServico (formOrdemServico) {
        Object.assign(this.ordemServico, {...formOrdemServico})
      },

      onDelete (index) {
        if (!this.ordemServico.itens[index].ordem_servico_item_id) {
          // como ainda não esta no banco irá excluir aqui mesmo
          this.ordemServico.itens.splice(index, 1)
        } else {
          const item = this.ordemServico.itens[index]

          this.ordemServico.itens.splice(index, 1)

          this.deleteds.itens.push(item)
        }
      },
      onCancel (selos, item, index) {
        // invertemos o flag_cancelado

        if (!item.flag_cancelado) {
          // caso flag_cancelado seja false
          // iremos mostrar um modal para o usuário escolher as acoes

          this.modal.data = item
          if (item.seloItemOs.length > 0) {
            this.modal.show = true
          } else {
            this.confirmAction()
          }


          /*selos.forEach(selo => {
            this.selos.canceleds.push(selo)
            if (this.selos.restoreds.indexOf(selo) != -1) {
              this.selos.restoreds.splice(this.selos.restoreds.indexOf(selo), 1)
            }
          })*/
        } else {
          // caso flag_cancelado seja true, irá ser jogado em restoreds e removido de canceleds
          selos.forEach(selo => {
            const { canceleds, deleteds, restoreds } = this.selos

            if (canceleds.indexOf(selo.selo_id) != -1) {
              canceleds.splice(this.selos.canceleds.indexOf(selo.selo_id), 1)
            } else if (deleteds.indexOf(selo.selo_id) != -1) {
              deleteds.splice(this.selos.deleteds.indexOf(selo.selo_id), 1)
            } else {
              restoreds.push(selo.selo_id)
            }
          })

          item.flag_cancelado = !item.flag_cancelado
          this.onChangeServico(item, index)
        }
      },
      deleteSelos (selos) {
        selos.forEach((seloItem) => {
          this.selos.deleteds.push(seloItem.selo.selo_id)
        })
      },
      async displayQuestion (title, text) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        return await Swal.fire(objSwal.question)
      },
      displayError (title, text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        return Swal.fire(objSwal.error)
      },
      imprimir (os) {
        this.$emit('imprimir', os)
      },
      deleteOS (os) {
        this.$emit('deleteOS', os)
      },
      getNameItensSelos () {
        const itens = this.ordemServico.itens.filter(item => {
          const selos = item.seloItemOs.filter(selo => this.selos.canceleds.indexOf(selo.selo_id) != -1)
          if (selos.length > 0) {
            return true
          } else {
            return false
          }
        }).map(item => item.custa.ato)

        return '<ul>' +
          '<li><b>' + itens.map(item => {
            if (item.split('').length > 100) {
              return item.substr(0, 100) + '...'
            } else {
              return item
            }
          }).join(`</b></li><li><b>`) + '</b></li>' +
          '</ul>'
      },
      getDiffHours (date) {
        return moment().diff(date, 'hours')
      },
      verifyTimeDiff (selo) {
        // pegamos a data_envio_tj d
        const { data_envio_tj } = selo

        return this.getDiffHours(data_envio_tj) > 72
      },
      seloModalAction (item, type) {
        // definindo os tipos possiveis: EXCLUSÃO/CANCELAR selo
        // deixando o valor invertido para facilitar a busca no dados do modal
        const typesInvert = {
          deleteds: 'canceleds',
          canceleds: 'deleteds'
        }

        // pegar outro tipo, se vir delete, vai retornar cancel
        const getInvert = (type) => {
          return typesInvert[type]
        }

        const deleteInInvert = () => {
          // pegamos o tipo invertido
          const invert = getInvert(type)

          // pegamos o index no array respectivo
          const index = this.modal[invert].indexOf(item)

          // caso tenha, será apagado
          if (index != -1) this.modal[invert].splice(index, 1)
        }

        // apagamos o selo
        deleteInInvert()

        // incluimos no novo array
        this.modal[type].push(item)
      },
      verifyInCanceleds (itemSelo) {
        // verifica se item esta no cancelados do modal
        const { canceleds } = this.modal
        return canceleds.find(canceled => canceled.selo_item_os_id == itemSelo.selo_item_os_id)
      },
      setOrdemJudicial (itemSelo, event) {
        // metodo que insere a ordem judicial dentro do selo em this.moda.canceleds
        // pegando value do evento
        const { target: { value } } = event
        const { canceleds } = this.modal

        // pegamos o indice do objeto
        const index = canceleds.indexOf(itemSelo)

        // jogamos o valor da ordem judcial dentro do objeto
        Object.assign(canceleds[index].selo, { num_ordem_judicial: value })
      },
      cancelModal () {
        // escondemos o modal
        this.modal.show = false

        // resetamos os dados
        this.modal.deleteds = []
        this.modal.canceleds = []
      },
      confirmAction () {
        const { deleteds, canceleds } = this.modal

        // pegando dados do modal
        const { data } = this.modal
        // pegando itens
        const { itens } = this.ordemServico

        // achamos o objeto
        const itemFinded = itens.find(item => item.ordem_servico_item_id == data.ordem_servico_item_id)

        // usamos o objeto para achar o indice
        const indexItem = itens.indexOf(itemFinded)

        // neste metodo irá ser jogado o deleteds, canceleds do modal
        // para o this.canceleds e this.deleteds
        const deleteRestored = (selo) => {
          const indexRestored = this.selos.restoreds.indexOf(selo.selo_id)
          if (indexRestored != -1) {
            this.selos.restoreds.splice(indexRestored, 1)
          }
        }

        const boot = (deletedConfirm = true) => {
          if (deletedConfirm) {
            deleteds.forEach(deleted => {
              deleteRestored(deleted.selo)
              this.selos.deleteds.push(deleted.selo.selo_id)
              //this.deleteds.itens.push(deleted)  TODO: item não vai ser excluido de fato
            })

            canceleds.forEach(canceled => {
              deleteRestored(canceled.selo)
              this.selos.canceleds.push(canceled.selo.selo_id)
            })

            // invertemos o flag_cancelado
            itemFinded.flag_cancelado = !itemFinded.flag_cancelado

            // aplicamos as mudanças
            this.onChangeServico(itemFinded, indexItem)
          }
        }

        // resetamos o modal
        this.cancelModal()


        this.$validator.validateAll().then(status => {
          if (status) {
            if (deleteds.length > 0) {
              objSwal.question.title = 'Atenção!'
              objSwal.question.text = 'Você realmente deseja excluir ' + (deleteds.length == 1 ? 'o selo' : 'os selos')  + '? Exclusões após 72h úteis podem gerar sanções para seu cartório.'
              objSwal.question.cancelButtonText = 'Não'
              objSwal.question.confirmButtonText = 'Sim'
              Swal.fire(objSwal.question).then(res => {
                if (res.value) {
                  boot(true)
                } else {
                  boot(false)
                }
              })
            } else {
              boot()
            }
          }
        })
      },
      imprimirRecibo (os) {
        this.$emit('imprimirRecibo', os)
      },
      rechargeOS () {
        this.$emit('rechargeOS')
      }
    }
  }
</script>

<style scoped>

</style>
